// routes
import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API;
export const ASSETS_API = process.env.REACT_APP_ASSETS_API;

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const AMPLIFY_API = {
  userPoolId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  region: process.env.REACT_APP_AWS_AMPLIFY_REGION,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL,
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'

export const PATH_AFTER_ADMIN_LOGIN = paths.adminDashboard.root;

// ROOT PATH AFTER SUPER-ADMIN LOGIN SUCCESSFUL
export const PATH_AFTER_SUPERADMIN_LOGIN = paths.superAdminDashboard.root;

// ROOT PATH AFTER USER LOGIN SUCCESSFUL
export const PATH_AFTER_SUPER_ADMIN_LOGIN = paths.superAdminDashboard.root;
export const FORGOT_PASSWORD = paths.auth.jwt.forgotPassword;
export const NEW_PASSWORD = paths.auth.jwt.newPassword;
export const VERIFY_PASSWORD = paths.auth.jwt.verify;

export const USER_TYPE_SUPER_ADMIN = 'admin';

export const USER_TYPE_TECHNICIAN = "technician";
export const USER_TYPE_CONTRACTOR = "contractor";
export const PROJECT_NAME = 'MobileWash Pro';
export const SUPPORT_EMAIL = 'support@mobilewashpro.com';

export const USER_TYPE_SHOPADMIN = 'shop_admin';

export const ROLES = {
  FULL_ACCESS: 'full_access',
  EDIT: 'edit',
  VIEW: 'view'
}


export const JOB_STATUSES = {
  PROSPECT: 'prospect',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  SCHEDULED: 'scheduled',
  REJECTED: 'rejected',
  EXPIRED: 'expired',
  DRAFTED: 'drafted',
};


export const PLATFORM_ACCESS = {
  SUPPORT_CENTER: 'support_center',
  TRAINING_ACADEMY: 'training_academy',
  CUSTOMER_HUB: 'customer_hub',
  BUILD_MODE: 'build_mode',
}


export const TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const PAYMENT_APPLICATION_STATUS_MAP = {
  created: "Not Started",
  onboarding: "Started (Not Complete)",
  started: "Started (Not Complete)",
  action_required: "Started (Not Complete)",

  account_review: "Submitted (In Review)",
  requires_pricing: "Submitted (In Review)",
  funding_hold: "Submitted (In Review)",

  active: "Approved/Enabled",
  partially_active: "Approved/Enabled",

  rejected: "Declined",
  disabled: "Declined",
  withdrawn: "Declined",
};
